import {AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import * as GaugeChart from 'gauge-chart';

@Component({
  selector: 'neq-gauge',
  template: '<div #gaugeArea></div>',
})
export class NeqGaugeComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('gaugeArea') gaugeArea;

  @Input() coherenceValue: number;
  @Input() tolerance = 0;

  private canvasWidth = 250;
  private options;

  private minValue: number;
  private amplitude: number;


  private element;
  private gaugeChart: any;

  ngOnInit() {

    this.minValue = (100 - this.tolerance - this.tolerance * 2 / 3);

    this.amplitude = (100 + this.tolerance + this.tolerance * 2 / 3) - this.minValue;

    // red amplitude
    const redAmplitude = (100 - this.tolerance) - this.minValue;

    // yellow amplitude
    const yellowAmplitude = (100 - this.tolerance * 2 / 3) - (100 - this.tolerance);


    this.options = {
      hasNeedle: true,
      needleColor: 'black',
      needleUpdateSpeed: 10,
      arcColors: [ '#c0392b', '#efcf4a', '#00aa00', 'black', '#00aa00', '#efcf4a', '#c0392b' ],
      arcDelimiters: [ redAmplitude * 100 / this.amplitude, (redAmplitude + yellowAmplitude) * 100 / this.amplitude,
        49.7, 50.3, 100 - (redAmplitude + yellowAmplitude) * 100 / this.amplitude, 100 - redAmplitude * 100 / this.amplitude ],
      needleStartValue: 50,
    };
  }

  ngAfterViewInit() {
    this.element = this.gaugeArea.nativeElement;
    this.constructGaugeComponent();
  }

  isIncoherent(): boolean {
    return !(this.coherenceValue < (100 - this.tolerance) || this.coherenceValue > (100 + this.tolerance));
  }

  ngOnChanges(changes) {
    if (changes.coherenceValue && !changes.coherenceValue.firstChange) {
      if (
        changes.coherenceValue.currentValue !== changes.coherenceValue.previousValue
      ) {
        this.coherenceValue = changes.coherenceValue.currentValue;
        this.constructGaugeComponent();
      }
    }

    if (changes.tolerance && !changes.tolerance.firstChange) {
      if (
        changes.tolerance.currentValue !== changes.tolerance.previousValue
      ) {
        this.tolerance = changes.tolerance.currentValue;
        this.constructGaugeComponent();
      }
    }
  }

  private calculNeedleValue() {
    return this.coherenceValue ? (this.coherenceValue - this.minValue) * 100 / this.amplitude : 50;
  }

  private constructGaugeComponent() {

    if (this.gaugeChart) {
      this.gaugeChart.removeGauge();
    }

    if (this.coherenceValue !== null && typeof this.coherenceValue !== 'undefined') { // to display 0
      this.options.centralLabel = '' + this.coherenceValue;
    } else {
      this.options.centralLabel = '-';
    }

    // Drawing and updating the chart
    this.gaugeChart = GaugeChart.gaugeChart(
      this.element,
      this.canvasWidth,
      this.options,
    );

    // Text value is colored in red if incoherent
    if (!this.isIncoherent()) {
      this.gaugeChart.svg.node().lastChild.style.fill = '#c0392b';
    }

    this.gaugeChart.svg.append('text')
      .attr('x', 37)
      .attr('y', 55)
      .text(100 - this.tolerance)
      .attr('font-size', '1.167rem');
    this.gaugeChart.svg.append('text')
      .attr('x', 197)
      .attr('y', 55)
      .text(100 + this.tolerance)
      .attr('font-size', '1.167rem');
    this.gaugeChart.updateNeedle(this.calculNeedleValue());
  }
}
